/* eslint-disable */
export default async function (context) {
  // $axios.onRequest((config) => {
  //   console.log('axios request config: ', config)
  //   console.log('Making request to ' + config.url)
  // })

  const { $axios, $config, $cookies, redirect } = context

  $axios.onError((error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.config?.url === `${$config.baseURL}/_api/api/v3/user`
    ) {
      $cookies.remove('auth._token.laravelSanctum', {
        domain: $config.cookieDomain,
        secure: $config.cookieSecure,
        path: '/',
      })
    }

    // Gestione Password Scaduta (Simulata/Predisposta)
    // Quando il backend implementerà il controllo, scommentare/adattare questo blocco
    /*
    const code = parseInt(error.response && error.response.status)
    // Esempio: se il backend restituisce 403 Forbidden con un messaggio specifico
    // o un codice custom (es. 423 Locked) per indicare password scaduta
    if (code === 403 && error.response?.data?.message === 'Password expired') {
       redirect('/area-riservata/rinnova-password')
       return
    }
    */

    // eslint-disable-next-line no-console
    console.log(error)
  })

  await $axios.get('/_api/sanctum/csrf-cookie')
}
